import store from '@/store/store.js'
import { INVOICE_ADDRESS_FETCH_ADDRESSES } from '@/store/addresses/invoice-addresses/action.types.js'
import { SENDER_ADDRESS_FETCH_ADDRESSES } from '@/store/addresses/sender-addresses/action.types.js'

import i18n from '@/i18n/i18n'

import axios from '@/utils/axios'
import EventBus from '@/utils/event-bus.js'

import ModalService from '@/services/modal.service.js'
import ToastService from '@/services/toast.service'

export default {
  show() {
    return this.checkForInitialAndSenderAddresses().then(() => {
      return new Promise((resolve, reject) => {
        if (this.isInitial()) {
          ModalService.build('InitialAddressModal')

          EventBus.$once('initial-address-modal:success', () => {
            ModalService.destroy()
            // One more isInitial check is required as it is possible that an address type other than
            // the invoice address has been created via the unified address form.
            if (!this.isInitial()) {
              resolve({
                senderAddress: store.getters.currentSenderAddress,
                invoiceAddress: store.getters.invoiceAddress,
              })
            }
          })

          EventBus.$once('initial-address-modal:dismiss', () => {
            ModalService.destroy()
            reject(Error())
          })
        } else {
          resolve(undefined)
        }
      })
    })
  },

  /**
   * Check if we already have addresses in the Vuex store. If not, fetch them.
   */
  async checkForInitialAndSenderAddresses() {
    try {
      if (store.getters.senderAddresses.length === 0) {
        await store.dispatch(SENDER_ADDRESS_FETCH_ADDRESSES)
      }

      if (store.getters.invoiceAddresses.length === 0) {
        await store.dispatch(INVOICE_ADDRESS_FETCH_ADDRESSES)
      }
    } catch (error) {
      ToastService.error(i18n.t('There was an error when checking your address details. Please try again.'))
      throw error
    }
  },

  isInitial() {
    const hasOnlyInitialSenderAddress = store.getters.senderAddresses.some(
      senderAddress => senderAddress.initial_address === true,
    )
    const hasOnlyInitialInvoiceAddress = store.getters.invoiceAddresses.some(
      invoiceAddress => invoiceAddress.initial_address === true,
    )
    return hasOnlyInitialSenderAddress && hasOnlyInitialInvoiceAddress
  },

  create(payload) {
    return axios.post('/xhr/users/me/update_initial_address', payload)
  },
}
